import { createSlice } from '@reduxjs/toolkit';
import { getCountryPhoneByCode } from '../../lib/countries';

const initialState = {
  countryCode: 'US',
  phoneNumber: '',
  fullPhoneNumber: '',
};

const receiverSlice = createSlice({
  name: 'receiver',
  initialState,
  reducers: {
    setReceiverCountryCode(state, action) {
      state.countryCode = action.payload;

      if (state.phoneNumber) {
        const phoneExt = getCountryPhoneByCode(action.payload);

        state.fullPhoneNumber = `${phoneExt}${state.phoneNumber}`;
      }
    },

    setReceiverPhoneNumber(state, action) {
      state.phoneNumber = action.payload;

      if (state.countryCode) {
        const phoneExt = getCountryPhoneByCode(state.countryCode);

        state.fullPhoneNumber = `${phoneExt}${action.payload}`;
      }
    },

    setReceiverPhoneAndCountry(state, action) {
      state.countryCode = action.payload.countryCode;
      state.phoneNumber = action.payload.phoneNumber;

      const phoneExt = getCountryPhoneByCode(state.countryCode);

      state.fullPhoneNumber = `${phoneExt}${action.payload.phoneNumber}`;
    },
  },
});

export const { setReceiverCountryCode, setReceiverPhoneNumber, setReceiverPhoneAndCountry } =
  receiverSlice.actions;

export default receiverSlice.reducer;
